module.exports = __webpack_public_path__ + "img/1.473b52f6.png";